import { Action, Reducer } from "redux";
import { SummaryState, SummaryTypes, SummaryActionTypes } from "./summaryTypes";

export const INITIAL_STATE: SummaryState = {
	summary: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const summaryReducer: Reducer<SummaryState> = (state: SummaryState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as SummaryActionTypes;
	switch (actionTypes.type) {
		case SummaryTypes.GET_SUMMARY:
			return {
				...state,
				summary: { ...state.summary, isLoading: true },
			};
		case SummaryTypes.SAVE_SUMMARY:
			return {
				...state,
				summary: {
					...state.summary,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case SummaryTypes.RESET_REDUCER_SUMMARY:
			return {
				...state,
				summary: INITIAL_STATE.summary,
			};
		default:
			return state;
	}
};

export default summaryReducer;
